import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Loading } from "app/components/Loading";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { UserHistoryByYear } from "./UserHistoryByYear";

export const UserHistoryYearList = ()=>{
    const [activeYear, setActiveYear] = useState(null);

    const { data:readingYearList, isLoading, isError, error } = useQuery({
        queryKey:['user/history/year/list'],
        queryFn:()=>Api.get('/api/user/result/year/list'),
        staleTime: 1000 * 60 * 60 * 24,
        gcTime: 1000 * 60 * 60 * 24,
    });

    const yearList = useMemo(()=>{
        if( isLoading ) return <Loading />;
        if( isError ) return <div className="no_data">{createFetchErrorMessage(error).message}</div>
        if(readingYearList?.data?.length===0){
            return <div className="no_data"><p>독서활동 내역이 없습니다.</p></div>
        }
        
        return readingYearList?.data?.map((year) => {
            const isOpen =  (activeYear===year);
            return (
                <div key={year}>
                    <h4 className={`year mgT0 ${(isOpen)?'_close':''} `} onClick={()=>{setActiveYear((activeYear===year)?null:year)}}>{year} 내가 읽은 책</h4>
                    {isOpen && <UserHistoryByYear year={year} /> }
                </div>
            )
        })
    }, [isLoading, readingYearList, activeYear, isError, error]);

    return (
        <div className="inner">
            <div className="history history_area">
                {yearList}
            </div>
        </div>
    );
};